module.exports = __webpack_public_path__ + "img/chat-primary.264d497.png";